import React from 'react';

import { Link } from 'react-router';
import { useTheme } from '@mui/material/styles';
import headLogoNew from '../../public/images/logo/logo-800x800.webp';
import useUser from '../../hooks/useUser';
import { Role } from '../Auth/PriorityRules';

function Logo(props) {
	const theme = useTheme();
	const { user } = useUser();

	const getHomeRedirectUri = (userRole) => {
		switch (userRole) {
			case Role.Teacher:
				return '/profesor';
			case Role.Admin || Role.Member:
				return '/';
			default:
				return '/';
		}
	};

	return (
		<Link to={props.cancelRedirect ? '#' : getHomeRedirectUri(user?.Role)}>
			<picture>
				<source
					srcSet={theme.palette.mode === 'light' ? headLogoNew : headLogoNew}
					media="(max-width: 480px)"
				/>
				<img
					style={{
						height: props.height ? props.height : '150px',
						marginTop: '15px',
						userSelect: 'none',
						width: props.height ? props.height : '150px',
						marginBottom: '10px'
					}}
					src={theme.palette.mode === 'light' ? headLogoNew : headLogoNew}
					alt="apro logo"
				/>
			</picture>
		</Link>
	);
}

export default Logo;
